import React from 'react';
import { Navbar } from '../components/sections/Navbar';
import { Hero } from '../components/sections/Hero';
import { Benefits } from '../components/sections/Benefits';
import { Process } from '../components/sections/Process';
import { Areas } from '../components/sections/Areas';
import { Doctor } from '../components/sections/Doctor';
import { Authority } from '../components/sections/Authority';
import { Cherry } from '../components/sections/Cherry';
import { Testimonials } from '../components/sections/Testimonials';
import { FAQ } from '../components/sections/FAQ';
import { Location } from '../components/sections/Location';
import { Contact } from '../components/sections/Contact';
import { Footer } from '../components/sections/Footer';
import { StickyMobileCta } from '../components/ui/StickyMobileCta';
import { CherryFloater } from '../components/ui/CherryFloater';
export function Home() {
  return <main className="min-h-screen bg-brand-cream" data-id="element-473">
      <Navbar data-id="element-474" />
      <Hero data-id="element-475" />
      <Benefits data-id="element-476" />
      <Process data-id="element-477" />
      <Areas data-id="element-478" />
      <Doctor data-id="element-479" />
      <Authority data-id="element-480" />
      <Cherry data-id="element-481" />
      <Testimonials data-id="element-482" />
      <FAQ data-id="element-483" />
      <Location data-id="element-484" />
      <Contact data-id="element-485" />
      <Footer data-id="element-486" />
      <StickyMobileCta data-id="element-487" />
      <CherryFloater data-id="element-488" />
    </main>;
}